import React, { useCallback, useState } from "react";
import { useDispatch } from "react-redux";
import PropTypes from 'prop-types';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, MenuItem, TextField } from "@mui/material";
import { bookEvent } from "../../../../actions/tmsActions";

const ModuleEventsBookDialog = ({open, events, eventId, onSelect, onBook, onCancel, onClose, ...others}) => (
    <Dialog
        open={open}
        onClose={onClose}
        fullWidth={true}
        maxWidth="sm"
        {...others}
    >
        <DialogTitle>Book event</DialogTitle>
        <DialogContent>
            <TextField
                variant="outlined"
                select
                label="Select event"
                helperText="select the event you wish to attend"
                defaultValue=""
                fullWidth
                autoFocus
            >
                {events.map(({id, dateStart}) => (
                    <MenuItem key={id} value={id} onClick={() => onSelect(id, dateStart)}>
                        {new Date(dateStart).toLocaleString('en-GB', { day: 'numeric', weekday: 'long', month: 'long', hour: 'numeric', minute: 'numeric'})}
                    </MenuItem>
                ))}
            </TextField>
        </DialogContent>
        <DialogActions>
            <Button key="cancel" onClick={onCancel}>Cancel</Button>
            <Button
                key="save"
                variant="contained"
                color="primary"
                onClick={() => { onBook(); onClose();}}
                disabled={!eventId}
            >
                Book
            </Button>
        </DialogActions>
    </Dialog>
);

const ModuleEventsBookContainer = ({open, moduleId, events, onCancel, onClose, ...others}) => {
    const dispatch = useDispatch();

    const [eventId, setEventId] = useState('');
    const [eventDate, setEventDate] = useState('');

    const handleCancel = () => { setEventId(''); setEventDate(''); onCancel(); }
    const handleClose = () => { setEventId(''); setEventDate(''); onClose(); }
    const handleSelect = useCallback((id, eventDate) => { setEventId(id); setEventDate(eventDate); }, []);
    const handleBook = () => dispatch(bookEvent(eventId, moduleId, 'C-TMS', eventDate));

    return (
        <ModuleEventsBookDialog
            open={open}
            events={events}
            eventId={eventId}
            onSelect={handleSelect}
            onBook={handleBook}
            onCancel={handleCancel}
            onClose={handleClose}
            {...others}
        />
    );
};

ModuleEventsBookContainer.propTypes = {
    open:     PropTypes.bool,
    moduleId: PropTypes.number.isRequired,
    events:   PropTypes.arrayOf(PropTypes.shape({
        id:        PropTypes.number,
        dateStart: PropTypes.string
    })),
    onCancel: PropTypes.func,
    onClose:  PropTypes.func
};

ModuleEventsBookContainer.defaultProps = {
    open:   false,
    events: [],
};

export default ModuleEventsBookContainer;
